package com.zaurh.mapquizwebsite.utils

import com.russhwolf.settings.Settings
import com.russhwolf.settings.set

class PreferencesManager(private val settings: Settings) {
    fun saveJwtToken(token: String) {
        settings["jwt_token"] = token
    }

    fun getJwtToken(): String? {
        return settings.getStringOrNull("jwt_token")
    }

    fun clearJWTToken() {
        settings["jwt_token"] = EMPTY
    }

    fun saveDarkMode(isDarkMode: Boolean) {
        settings["dark_mode"] = isDarkMode
    }

    fun getDarkMode(): Boolean {
        return settings.getBoolean("dark_mode", false)
    }

    fun saveNotificationEnabled(enabled: Boolean) {
        settings["notification_enabled"] = enabled
    }

    fun getNotificationEnabled(): Boolean {
        return settings.getBoolean("notification_enabled", false)
    }


    fun saveLanguage(language: String) {
        settings["language"] = language
    }

    fun getLanguage(): String {
        return settings.getString("language", "EN")
    }
}

expect fun provideSettings(context: Any? = null): Settings